<li class="px-3" (click)="onClick($event)" (mouseenter)="onHover()" [class.active]="active"
    [ngClass]="{'d-none':isFiltered()}">
  <div class="d-flex align-items-center">
    <input *ngIf="isMultiple()" class="form-check-input me-2" type="checkbox" id="{{ getId() }}" [checked]="isChecked()"
           (change)="onChange($event)">
    <label for="{{ getId() }}" #template>
      <ng-content></ng-content>
    </label>
  </div>
</li>
